function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M28.094 21.979a2.029 2.029 0 01-.71 1.522L4.357 42.571a2.029 2.029 0 01-2.536-3.145l21.1-17.447L.909 3.72A2.029 2.029 0 113.445.575l23.837 19.882a1.927 1.927 0 01.811 1.522z"
});

function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.094 42.908"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyOC4wOTQgNDIuOTA4Ij4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZD0iTTI4LjA5NCAyMS45NzlhMi4wMjkgMi4wMjkgMCAwMS0uNzEgMS41MjJMNC4zNTcgNDIuNTcxYTIuMDI5IDIuMDI5IDAgMDEtMi41MzYtMy4xNDVsMjEuMS0xNy40NDdMLjkwOSAzLjcyQTIuMDI5IDIuMDI5IDAgMTEzLjQ0NS41NzVsMjMuODM3IDE5Ljg4MmExLjkyNyAxLjkyNyAwIDAxLjgxMSAxLjUyMnoiLz4KPC9zdmc+";
export { SvgChevronRight as ReactComponent };